import React, {useContext, useState} from 'react'
import CustomerManagerForm from './form/CustomerManagerForm'
import {CustomerManagerContext} from "./../context/CustomerManagerContext";
import Filter from "../../../statics/assets/icons/filter.svg";
import CustomerManagerFilters from "./filters/CustomerManagerFilters";
import {Pagination} from "antd";
import CustomerManagerTable from "./table/CustomerManagerTable";
import {Link} from "react-router-dom";
import {getLocalData} from "../../../services/StorageServices";
import DeleteCustomer from "./actions/DeleteCustomer";

function CustomerManagerPage(props) {
    const {listName} = props
    const listCustomersFilters = getLocalData('listCustomersFilters') || {}
    const searchParams = new URLSearchParams()
    Object.keys(listCustomersFilters).forEach(key => searchParams.append(key, listCustomersFilters[key]))
    const queryString = searchParams.toString() ? '?' + searchParams.toString() : ''
    const CustomerManagerPageContext = useContext(CustomerManagerContext)
    const {
        detailListCustomers,
        total,
        page,
        limit,
        loading,
        error,
        filters,
        setFiltersState,
        setLimit,
        setPage,
        fetchDetailListCustomers,
        listCusID
    } = CustomerManagerPageContext
    const [showFilters, toggleFilters] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [arrSelected, setArrSelected] = useState([])

    const _toggleShowFilter = () => {
        toggleFilters(!showFilters)
    }

    const _onChangePagination = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _handleCheckALl = (isChecked) => {
        if (isChecked) {
            const selectedLead = detailListCustomers.map(itemL => itemL.customerId)
            setArrSelected(selectedLead)
            setSelectAll(true)
        } else {
            setArrSelected([])
            setSelectAll(false)
        }
    }

    const _handleClearChecked = () => {
        setArrSelected([])
        setSelectAll(false)
    }

    const _updateSelected = (id, isAdded) => {
        if (isAdded && !arrSelected.includes(id)) {
            setArrSelected([...arrSelected, id])
            setSelectAll(arrSelected.length + 1 === detailListCustomers.length)
        } else {
            const filtered = arrSelected.filter(item => item !== id)
            setArrSelected(filtered)
            setSelectAll(false)
        }
    }

    return <div className='CustomerManagerPage PageDefault position-relative'>
        <div className="PageHeading">
            <div>
                <Link to={`/crm/list-customers${queryString}`} className="d-flex align-items-center mb-2">
                    <span className="material-icons">arrow_back</span>
                    <span className="Title">Back</span>
                </Link>
                <h1 className="PageTitle">{listName.name}</h1>
            </div>
            <div className="d-flex align-items-center PageFilterTop">
                <div className={`Filter mr-3 ${showFilters && 'filtersOpen'}`}>
                    <label onClick={_toggleShowFilter}><Filter width={20} height={20}/>Bộ lọc</label>
                </div>
                {arrSelected.length > 0 && <DeleteCustomer
                    arrSelected={arrSelected}
                    fetchDetailListCustomers={fetchDetailListCustomers}
                    listCusID={listCusID}
                    onClearChecked={_handleClearChecked}
                />}
                <CustomerManagerForm listName={listName} listCusID={listCusID}/>
            </div>
        </div>
        {showFilters && <CustomerManagerFilters filters={filters} setFiltersState={setFiltersState}/>}
        <div className="PageTable">
            <CustomerManagerTable
                loading={loading}
                error={error}
                detailListCustomers={detailListCustomers}
                selectAll={selectAll}
                arrSelected={arrSelected}
                onCheckALl={_handleCheckALl}
                onSelected={_updateSelected}
            />
            <div className="PagePagination">
                <Pagination
                    className="PaginationCustom"
                    total={total}
                    pageSize={limit}
                    current={page}
                    onChange={_onChangePagination}
                />
            </div>
        </div>
    </div>
}

export default CustomerManagerPage
